import React, { useState } from 'react';
import { useTranslations } from 'next-intl';

import { ITeacher } from 'modules/courses';

import About from './about';
import Courses from './courses';
import Tests from './tests';

interface ITab {
  id: string;
  label: string;
  content: React.ReactNode;
}

interface IProps {
  teacher?: ITeacher;
  isLoading?: boolean;
}

const Tabs: React.FC<IProps> = ({ teacher, isLoading }) => {
  const t = useTranslations();
  const [activeTab, setActiveTab] = useState('about');

  const tabs: ITab[] = [
    { id: 'about', label: t('ustoz_haqida'), content: <About teacher={teacher} /> },
    {
      id: 'courses',
      label: t('kurslar'),
      content: <Courses courses={teacher?.courses} isLoading={isLoading} />
    },
    { id: 'tests', label: t('topicTestsTitle'), content: <Tests teacherId={teacher?.id} /> },
  ];

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  return (
    <div className="w-full">
      <div className="flex items-center">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab.id)}
            className={`
              relative cursor-pointer px-4 pb-3 text-sm font-medium transition-all duration-300
              ease-in-out hover:text-green-600 focus:text-green-600
              focus:outline-none
              ${activeTab === tab.id ? 'text-green-600' : 'text-gray-600 hover:text-gray-800'}
            `}
          >
            {tab.label}
            <div
              className={`
                absolute bottom-0 left-0 h-0.5 bg-green-600 transition-all duration-300 ease-in-out
                ${activeTab === tab.id ? 'w-full opacity-100' : 'w-0 opacity-0'}
              `}
            />
          </button>
        ))}
      </div>

      <div className="mt-4">
        <div className="transition-all duration-300 ease-in-out">{tabs.find(tab => tab.id === activeTab)?.content}</div>
      </div>
    </div>
  );
};

export default Tabs;
